import { EditChatTabNames, ChatDetailsResponse } from '@choco-admin/types';
import React from 'react';

import { ChatHistoryTabPanel } from './tabs/ChatHistoryTabPanel';
import { ParticipantsTabPanel } from './tabs/ParticipantsTabPanel';
import { SettingsTabPanel } from './tabs/SettingsTabPanel';

interface EditChatTabPanelsProps {
  activeTab: EditChatTabNames;
  chatData: ChatDetailsResponse;
  chatId: string;
}

export const EditChatTabPanels: React.FC<EditChatTabPanelsProps> = ({
  activeTab,
  chatData,
  chatId,
}) => {
  const renderTabPanel = () => {
    switch (activeTab) {
      case EditChatTabNames.PARTICIPANTS:
        return <ParticipantsTabPanel chatData={chatData} chatId={chatId} />;

      case EditChatTabNames.SETTINGS:
        return <SettingsTabPanel chatData={chatData} chatId={chatId} />;

      case EditChatTabNames.CHAT_HISTORY:
        return <ChatHistoryTabPanel chatData={chatData} chatId={chatId} />;

      default:
        return <ParticipantsTabPanel chatData={chatData} chatId={chatId} />;
    }
  };

  return <div className="w-full">{renderTabPanel()}</div>;
};
